"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductSortOptionLabel = exports.DEFAULT_PRODUCT_SORT_OPTION = exports.PRODUCT_SORT_OPTIONS = void 0;
exports.PRODUCT_SORT_OPTIONS = [
    'best-selling',
    'recommended',
    'price-low-high',
    'price-high-low',
    'newest-first',
    'star-rating',
    'alphabetical-a-z',
    'alphabetical-z-a',
];
exports.DEFAULT_PRODUCT_SORT_OPTION = 'best-selling';
const getProductSortOptionLabel = (option) => {
    switch (option) {
        case 'best-selling':
            return 'Best Selling';
        case 'recommended':
            return 'Recommended';
        case 'price-low-high':
            return 'Lowest price';
        case 'price-high-low':
            return 'Highest price';
        case 'newest-first':
            return 'Newest';
        case 'star-rating':
            return 'Star Rating';
        case 'alphabetical-a-z':
            return 'Alphabetical A - Z';
        case 'alphabetical-z-a':
            return 'Alphabetical Z - A';
        default:
            return 'Recommended';
    }
};
exports.getProductSortOptionLabel = getProductSortOptionLabel;
